<template lang="pug">
transition(name="fade" mode="out-in")
  router-view(
    :canCreateSegments="canCreateSegments"
    :canEditSegments="canEditSegments"
    :enableMultilanguage="enableMultilanguage")
</template>

<script>
export default {
  name: 'VisitorClassifications',
  props: {
    canCreateSegments: Boolean,
    canEditSegments: Boolean,
    enableMultilanguage: Boolean,
  },
}
</script>

<style lang="stylus">
.top-line
  width 100%
  display flex
  justify-content space-between
  margin-bottom 4em
</style>
